export const mediaErrors = {
  invalidType: 'Invalid media type specified',
};
